import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Parser from "html-react-parser";
import * as CMSActions from "./store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import { animations } from "react-animation";
import "./BannerHero.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;

function BannerHero(props) {
  const dispatch = useDispatch();

  const is4K = useMediaQuery("(min-width: 3840px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const [backgroundImage, setBackgroundImage] = useState([]);
  const [heroImage, setHeroImage] = useState("");
  const [buttonConsultar, setButtonConsultar] = useState({});
  //const [buttonWhatsapp, setButtonWhatsapp] = useState([]);
  const [bannerText, setBannerText] = useState([]);

  const { contentBanner } = useSelector(({ banner }) => banner.banner);

  useEffect(() => {
    !contentBanner && dispatch(CMSActions.getBanner());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (contentBanner) {
      setBackgroundImage(contentBanner.aCBannerBackground);
      setBannerText(contentBanner.aCBannerText);
      setHeroImage(contentBanner.aCBannerMainImage[0]?.mainImage?.urls[0]);
      // Validación para crear el botón consultar
      contentBanner.aCBannerButtonConsultarImage &&
        contentBanner.aCBannerButtonConsultarImage[0]?.url &&
        contentBanner.aCBannerButtonConsultarImage[0]?.url.url &&
        contentBanner.aCBannerButtonConsultarImage[0]?.botonConsultar.urls[0] &&
        setButtonConsultar({
          url: contentBanner.aCBannerButtonConsultarImage[0].url.url,
          img: contentBanner.aCBannerButtonConsultarImage[0].botonConsultar
            .urls[0],
          alt: contentBanner.aCBannerButtonConsultarImage[0].url.text,
        });
      //setButtonWhatsapp(contentBanner.aCBannerButtonWhatsappImage);
    }
  }, [contentBanner]);

  const bgImage = () => {
    let cls = "";
    if (isIphoneLandscape) {
      cls = `url("${ROOT + backgroundImage[0]?.bGMobile?.urls[0]}")`;
    } else if (isIpadPortrait) {
      cls = `url("${ROOT + backgroundImage[0]?.bGIpadPortrait?.urls[0]}")`;
    } else if (isDesktop) {
      cls = `url("${
        ROOT + backgroundImage[0]?.bG4KDesktopIpadLandscape?.urls[0]
      }")`;
    }
    return cls;
  };

  const contenedorL4L5YConsultar = () => {
    let cls = "";
    if (isIphoneLandscape) {
      cls = "d-flex flex-column";
    } else if (isIpadPortrait || isDesktop || is4K) {
      cls = "d-flex";
    }
    return cls;
  };

  const mainImage = (
    <>
      {backgroundImage && (
        <>
          <div
            className="background-container main-banner-container"
            style={{
              backgroundImage: bgImage(),
              backgroundPosition: "center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              zIndex: 1,
            }}
          >
            <div className="containerTexto">
              {bannerText[0]?.linea1 && (
                <div className="linea1">
                  {Parser(bannerText[0]?.linea1?.html)}
                </div>
              )}
              {bannerText[0]?.linea2 && (
                <div className="linea2">
                  {Parser(bannerText[0]?.linea2?.html)}
                </div>
              )}
              {bannerText[0]?.linea3 && (
                <div className="linea3">
                  {Parser(bannerText[0]?.linea3?.html)}
                </div>
              )}
              <div className={contenedorL4L5YConsultar()}>
                {(bannerText[0]?.linea4 || bannerText[0]?.linea5) && (
                  <div
                    className="d-flex flex-column justify-content-center"
                    style={{ marginRight: "32px" }}
                  >
                    {bannerText[0]?.linea4 && (
                      <div className="linea4" style={{ whiteSpace: "nowrap" }}>
                        {Parser(bannerText[0]?.linea4?.html)}
                      </div>
                    )}
                    {bannerText[0]?.linea5 && (
                      <div className="linea5" style={{ whiteSpace: "nowrap" }}>
                        {Parser(bannerText[0]?.linea5?.html)}
                      </div>
                    )}
                  </div>
                )}
                {buttonConsultar && buttonConsultar.url && buttonConsultar.img && (
                  <div className="my-auto" style={{ height: "50px" }}>
                    <a
                      href={buttonConsultar.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="h-100"
                        src={ROOT + buttonConsultar.img}
                        alt={buttonConsultar.alt}
                      />
                    </a>
                  </div>
                )}
              </div>
            </div>
            <div className="containerMainImage">
              {heroImage && (
                <img
                  alt="heroImage"
                  src={ROOT + heroImage}
                  className="hero-image"
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );

  return (
    <div
      className="d-flex justify-content-center"
      style={{ animation: animations.fadeIn }}
    >
      <div className="d-flex flex-fill position-relative align-items-center">
        {mainImage}
      </div>
    </div>
  );
}

export default BannerHero;